import { useFeatureValue } from '@growthbook/growthbook-react';
import { useTabLabels } from './useTabLabels';

export const useCaseDetailsFeatures = (rpc: boolean): string[] => {
  const tabLabels = useTabLabels(rpc);
  if (
    useFeatureValue('disable_related_consultee_cases', false) &&
    tabLabels.indexOf('Related cases') !== -1
  ) {
    tabLabels.splice(tabLabels.indexOf('Related cases'), 1);
  }
  if (
    useFeatureValue('disable_consultee_comments', false) &&
    tabLabels.indexOf('Comments') !== -1
  ) {
    tabLabels.splice(tabLabels.indexOf('Comments'), 1);
  }

  return tabLabels;
};
